import { useContext } from 'react';
import { ClientContext } from './Context';
var useClient = function useClient() {
  return useContext(ClientContext);
};
export default useClient;